export default {
  title: 'MAXHUB Activate',
  instruction: 'Пожалуйста, правильно заполните информацию о пользователе и продавце, поскольку она может иметь важное значение для послепродажного обслуживания',
  dealername: 'Наименование продавца',
  dealerplaceholder: 'Наименование продавца',
  companyname: 'Название компании',
  companyplaceholder: 'Название компании',
  tele: 'Контактная информация',
  teleplaceholder: 'Мобильный телефон',
  district: 'Выбранная территория',
  distplaceholder: 'Информация о территории',
  address: 'Полный адрес',
  addrplaceholder: 'Полный адрес',
  activebtn: 'Получить код активации',
  confirmbtn: 'Подтвердить',
  cancelbtn: 'Отменить',
  dialogmessage: 'Неправильный формат мобильного телефона, пожалуйста, вновь введите номер',
  dialogbtn: 'Подтвердить',
  errortitle: 'Не удается открыть',
  errorinfo1: 'Попробуйте проверить сетевое подключение',
  errorinfo2: 'Горячая линия 400-168-9545',
  nosn: 'Невозможно активировать устройства, поскольку отсутствует СН',
  activepagetitle: 'Код активации',
  activepagehint: 'Для активации устройства введите код активации',
  finish: 'закончить',
  search: 'поиск по соседству'
};



// WEBPACK FOOTER //
// ./src/i18n/_ru.js